
import { defineComponent, ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import {
  DocumentReportDto,
  GetAgingReportResponse,
  GetAgingReportRequest,
} from "@/types";
import StatusBadge from "@/components/StatusBadge.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useSessionState } from "@/store";
import { useSessionStorage } from "@vueuse/core";

export default defineComponent({
  name: "AgingReport",
  components: { StatusBadge },
  setup() {
    const {
      setLoading,
      axios,
      success,
      error,
      dayjs,
      onRouterPush,
      formatAppDate,
    } = usePlugin();
    const selectedDate = useSessionStorage<Date[]>("agingReport-selectedDate", [
      dayjs()
        .startOf("month")
        .toDate(),
      dayjs()
        .endOf("month")
        .toDate(),
    ]);
    const reports = ref<DocumentReportDto[]>([]);
    const filters: { [key: string]: any } = useSessionStorage(
      "agingReport-filters",
      {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "supervisor.id": { value: null, matchMode: FilterMatchMode.CONTAINS },
        "employee.id": { value: null, matchMode: FilterMatchMode.CONTAINS },
        age: {
          value: null,
          matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
        },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
      }
    );

    const statuses = computed(() => [
      ...new Set(reports.value.map((x) => x.status).sort()),
    ]);

    const onQueryReport = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetAgingReportResponse>(
          "api/v1/services/report/aging",
          {
            selectedDate: selectedDate.value,
          } as GetAgingReportRequest
        );

        reports.value = result.data.reports ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onGoToDocument = (id: string) => {
      if (id.indexOf("|") >= 0) {
        const keys = id.split("|");
        onRouterPush({
          name: "viewAssessment",
          params: {
            documentId: keys[0],
            questionId: keys[1],
            employeeId: keys[2],
          },
        });
      } else {
        onRouterPush({ name: "positionAssessment", params: { id: id } });
      }
    };

    onMounted(() => {
      onQueryReport();
    });

    //Convert to date just before setup complete
    selectedDate.value[0] = dayjs(selectedDate.value[0]).toDate();
    selectedDate.value[1] = dayjs(selectedDate.value[1]).toDate();

    return {
      selectedDate,
      onQueryReport,
      reports,
      onGoToDocument,
      formatAppDate,
      filters,
      statuses,
    };
  },
});
